


export default class Abonement {
    constructor(form) {
        this.form = form;
        $(".activation").on('click', this._abonementOrderCheckIn);
        $('.abonement-sms').on('click', this._checkInSMSCode);
        $('.abonement input').on("keyup paste", this._activeClassAct)
        $('.sms-box input').on("keyup paste", this._activeClassSms)
    }

    _activeClassAct(e) {
        let currentForm = $(e.target).parents("form")[0];

        var _this = e.target;
        window.setTimeout(function () {
            var length = $(_this).val().length;
            if (length === 6) {
                $(currentForm).find(".activation-box button").addClass('active');
            } else {
                $(currentForm).find(".activation-box button").removeClass('active');
            }
        });
    }

    _activeClassSms(e) {
        let currentForm = $(e.target).parents("form")[0];

        var _this = e.target;
        window.setTimeout(function () {
            var length = $(_this).val().length;
            if (length === 6) {
                $(currentForm).find(".sms-box button").addClass('active');
            } else {
                $(currentForm).find(".sms-box button").removeClass('active');
            }
        });
    }

    _abonementOrderCheckIn(e) {
        let currentForm = $(e.target).parents("form")[0];
        var dataToSend = {
            "type" : "abonementOrderCheckIn",
            "seminar" : currentForm.querySelector('input[name="seminar"]').value,
            "abonement" : {
                "number" : currentForm.querySelector('.abonement input').value
            }
        };
        var _this = this;

        let spanForError = currentForm.querySelector('.abonement span');
  

        $.ajax({
            type: "POST",
            url: location.href,
            data: JSON.stringify(dataToSend),
            cache: false,
            contentType: false,
            processData: false
        }).done(function (data) {
            var txt = JSON.parse(data);

            if (spanForError) {
                spanForError.remove();
            }
            if (txt.error) {
                $(currentForm.querySelector('.abonement')).append('<span class="error">'+txt.error+'</span>');
                $(_this).removeClass("active");
            } else {
                $(_this).addClass("active");
                $(_this).parent().hide();
                $(_this).parent().next().show();
                $(currentForm.querySelector('.abonement *')).css('pointer-events', 'none');
            }
        }).fail(function (data) {
            var txt = data.responseText ? JSON.parse(data.responseText) : {};
            if (spanForError) {
                spanForError.remove();
            }
            $(currentForm.querySelector('.abonement')).show().append('<span class="error">'+txt.error+'</span>');
        });
    }
    _checkInSMSCode (e) {
        let currentForm = $(e.target).parents("form")[0];

          var abonamenetNamber = currentForm.querySelector('.abonement input').value;
          var dataToSend = {
              "type": "checkInSMSCode",
              "code": currentForm.querySelector('#sms-code').value
          };
          var _this = this;
          $.ajax({
              type: "POST",
              url: location.href,
              data: JSON.stringify(dataToSend),
              cache: false,
              contentType: false,
              processData: false
          }).done(function (data) {
              var txt = data ? JSON.parse(data) : {};
              $(_this).parent().hide();
              $(currentForm.querySelector('.sms-box span')).remove();
              $(currentForm.querySelector('.sms-box')).show().append('<span class="success">' + txt.message + '</span>');
              $(currentForm.querySelector('.sms-box .sms-container')).hide();
              $(currentForm.querySelector('.payment_type')).remove();
              $(currentForm.querySelector('.abonement input')).css('pointer-events', 'none');
              $(currentForm.querySelector('.abonement')).append('<input name="abonementNumber" id="abonementNumber" value="' + abonamenetNamber + '" type="hidden">');
          }).fail(function (data) {
              var txt = data.responseText ? JSON.parse(data.responseText) : {};
              $(currentForm.querySelector('.sms-box span')).remove();
              $(currentForm.querySelector('.sms-box')).show().append('<span class="error">' + txt.error + '</span>');
              $( currentForm.querySelector('.abonement')).find('.abonementNumber').remove();
          });
      }


}